import { render, staticRenderFns } from "./terminalDateTips.vue?vue&type=template&id=72474e7c&scoped=true"
import script from "./terminalDateTips.vue?vue&type=script&lang=js"
export * from "./terminalDateTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72474e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72474e7c')) {
      api.createRecord('72474e7c', component.options)
    } else {
      api.reload('72474e7c', component.options)
    }
    module.hot.accept("./terminalDateTips.vue?vue&type=template&id=72474e7c&scoped=true", function () {
      api.rerender('72474e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-k/components/terminalDateTips.vue"
export default component.exports